<template>
  <div style="margin-top: 2.75rem">
    <section v-if="!!career" class="container">
      <div class="row">
        <div class="col-12 col-md-12">
          <div class="itb-input-like-group itb-margin-bottom">
            <div class="itb-label itb-font-bold">
              {{ $t("careers.job_position") }}
            </div>
            <div class="itb-text itb-job-offer-long-text">
              {{ career.job_position }}
            </div>
          </div>
          <div class="itb-input-like-group itb-big itb-margin-bottom">
            <div class="itb-label itb-font-bold">
              {{ $t("careers.company_introduction") }}
            </div>
            <div class="itb-text itb-job-offer-long-text">
              {{ career.company_introduction }}
            </div>
          </div>
          <div class="itb-input-like-group itb-big itb-margin-bottom">
            <div class="itb-label itb-font-bold">
              {{ $t("careers.job_description") }}
            </div>
            <div class="itb-text itb-job-offer-long-text">
              {{ career.job_description }}
            </div>
          </div>
          <div class="itb-input-like-group itb-big itb-margin-bottom">
            <div class="itb-label itb-font-bold">
              {{ $t("careers.applicant_requirements") }}
            </div>
            <div class="itb-text itb-job-offer-long-text">
              {{ career.applicant_requirements }}
            </div>
          </div>
          <div class="itb-input-like-group itb-big itb-margin-bottom">
            <div class="itb-label itb-font-bold">
              {{ $t("careers.employee_benefits") }}
            </div>
            <div class="itb-text itb-job-offer-long-text">
              {{ career.employee_benefits }}
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="itb-hero-cards-contact itb-job-offer-contact-info">
      <div class="container">
        <h2 class="mb-0">{{ $t("contacts.career_section_title") }}</h2>
        <p class="h3 mb-3">
          {{ $t("contacts.career_section_subtitle") }}
        </p>
        <div
          class="row d-flex align-content-center mx-0 itb-bg itb-lazy-loading-bg mb-0"
          v-lazy:background-image="'/images/articles/contact-main.webp'"
        >
          <div class="col-12 col-md-8 offset-md-4 col-xl-6 offset-xl-6 p-0">
            <div class="card">
              <div class="card-body">
                <div class="row">
                  <div class="col-12 col-md-6 mb-4 mb-md-0">
                    <h2>
                      {{ appParams.general_company_name }}
                    </h2>
                    <p class="m-0">
                      {{ appParams.general_company_street }}
                    </p>
                    <p class="m-0">
                      {{ appParams.general_company_city }}
                    </p>
                    <p class="m-0">
                      {{ $t("contacts.ico") }}:
                      {{ appParams.general_company_ico }}
                    </p>
                    <p class="m-0">
                      {{ $t("contacts.dic") }}:
                      {{ appParams.general_company_dic }}
                    </p>
                  </div>
                  <div class="col-12 col-md-6 pl-xl-0">
                    <h3>
                      {{ $t("contacts.email_for_job_offer") }}
                    </h3>
                    <p class="m-0">
                      <a
                        :href="
                          'mailto:' +
                          appParams.general_email +
                          '?Subject=' +
                          $t('general.email_subject')
                        "
                        itemprop="email"
                        >{{ appParams.general_email }}</a
                      >
                    </p>
                  </div>
                </div>
                <hr />
                <div class="row">
                  <div class="col-12 col-md-6 mb-4 mb-md-0">
                    <p class="m-0 itb-info" style="margin-bottom: 1rem">
                      {{ appParams.general_company_dic_text }}
                    </p>
                  </div>
                  <div class="col-12 col-md-6 pl-xl-0">
                    <h3>
                      {{ $t("contacts.or_call") }}
                    </h3>
                    <p class="m-0">
                      <a
                        :href="'tel:' + stripedPhone(appParams.general_phone)"
                        itemprop="telephone"
                        >{{ appParams.general_phone }}</a
                      >
                      <span
                        class="text-muted"
                        style="font-size: 80%; position: relative; top: -2px"
                        >{{ $t("contacts.open_hours") }}</span
                      >
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      pageParams: [],
      career: null,
      isBreakPointLarge: true,
      isBreakPointMedium: false,
      contactParams: null,
    };
  },

  created() {
    this.onResize();
    window.addEventListener("resize", this.onResize);
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  mounted() {
    axios
      .get("/getCareerDetailPage/" + this.$route.params.careerAlias)
      .then((response) => {
        this.pageParams = response.data.params;
        this.career = response.data.career;
        this.setPageParams(this.pageParams);
      })
      .catch((error) => {
        console.log(error);
      });
  },

  computed: {
    ...mapGetters({
      appParams: "getAppParams",
    }),
  },

  methods: {
    ...mapActions(["setPageParams"]),

    onResize() {
      if (window.innerWidth >= 1570) {
        this.isBreakPointLarge = true;
      } else {
        this.isBreakPointLarge = false;
      }

      if (window.innerWidth < 992) {
        this.isBreakPointMedium = true;
      } else {
        this.isBreakPointMedium = false;
      }
    },

    stripedPhone(phone) {
      return phone ? String(phone).replace(/\s/g, "") : "";
    },
  },
};
</script>
